export default __webpack_public_path__ + "static/media/ic1.a6360760.svg";